import React, { useState, useEffect, Link } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "../../index.js";
import { useSelector, useDispatch } from 'react-redux';
import { update_amount_orders, update_discount_orders, update_category_pro_lite, update_category_service, update_category_pro_max } from './actions';
import Language_i18 from '../../js/useNationalLanguage.jsx';

function Ordergoogle({ peding_service, isOpen3, setIsOpen3, isOpen4, setIsOpen4 }) {
    const { slug_2, slug_3, slug_4 } = useParams();
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const { i18n, lang } = Language_i18();
    const [category_pro_max_disabled, set_category_pro_max_disabled] = useState(true);
    const [category_pro_disabled, set_category_pro_disabled] = useState(true);
    const category_pro_lite = useSelector(state => state.category_pro_lite);
    const category_pro_max = useSelector(state => state.category_pro_max);

    const dispatch = useDispatch();
    const set_category_pro_lite = (value) => {
        dispatch(update_category_pro_lite(value));
    };
    const set_category_pro_max = (value) => {
        dispatch(update_category_pro_max(value));
    };

    const [category_pros_max, set_category_pros_max] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const [category_pros_lite, set_category_pros_lite] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const handleFocus3 = () => {
        setIsOpen3(true);
        console.log(123);
    };
    const handleFocus4 = () => {
        setIsOpen4(true);
        console.log(123);
    };
    const handleBlur3 = () => {
        setIsOpen3(false);
    };
    const handleBlur4 = () => {
        setIsOpen4(false);
    };
    const handleMenuOpen3 = () => {
        setIsOpen3(true);
    };
    const handleMenuOpen4 = () => {
        setIsOpen4(true);
    };
    function xuly_category_pro_max(response) {
        if (response.data && Array.isArray(response.data)) {
            set_category_pros_max(response.data);
            localStorage.setItem('category_pros_max', JSON.stringify(response.data));
            set_category_pro_max_disabled(false);
            setIsOpen3(true);
            peding_service(false);
        } else {
            set_category_pros_max([]);
            localStorage.removeItem('category_pros_max');
            console.error("Unexpected response format:", response.data);
        }
    }

    useEffect(() => {
        if (!slug_3) {
            setIsOpen3(true);
            localStorage.removeItem('category_pro_lite');
            localStorage.removeItem('category_pros_lite');
            localStorage.removeItem('category_pro_max');
            localStorage.removeItem('category_pros_max');
            if (slug_2 == 'play') {
                get_info_category_pro_max('accounts');
            } else {
                get_info_category_pro_max(slug_2);
            }
        } else {
            set_category_pro_max_disabled(Cookies.get("category_pro_max_disabled") === "true");
            set_category_pro_disabled(Cookies.get("category_pro_disabled") === "true");

            set_category_pros_max(
                JSON.parse(localStorage.getItem('category_pros_max') || '[]')
            );
            set_category_pro_max(
                JSON.parse(localStorage.getItem('category_pro_max') || '[]')
            );
            set_category_pro_lite(
                JSON.parse(localStorage.getItem('category_pro_lite') || '[]')
            );
            set_category_pros_lite(
                JSON.parse(localStorage.getItem('category_pros_lite') || '[]')
            );
        }
    }, []);

    const get_info_category_pro_max = async (value) => {
        try {
            peding_service(true);
            const apikey = Cookies.get("apikey");
            const response = await axios.get("https://hust.media/getservice/category_pro_max.php", {
                params: {
                    apikey: apikey,
                    chedo: "laythongtin",
                    option_category_pro_max: value
                }
            });
            // Xử lý dữ liệu trả về ở đây
            return xuly_category_pro_max(response);
        } catch (error) {
            // Xử lý lỗi ở đây
            console.log(error);
        }
    };
    const get_info_category_pro = async (value) => {
        try {
            if (value === "hust_mmo") {
                navigate("/shop/p2p/mmo/orders/home");
                return;
            }
            peding_service(true);
            const apikey = Cookies.get("apikey");
            const response = await axios.get("https://hust.media/getservice/category_pro_lite.php", {
                params: {
                    apikey: apikey,
                    option_category_pro: value
                }
            });
            // Xử lý dữ liệu trả về ở đây
            return xuly_category_pro(response);
        } catch (error) {
            // Xử lý lỗi ở đây
            console.log(error);
        }
    };
    const xuly_category_pro = (response) => {
        set_category_pros_lite(response.data);
        localStorage.setItem('category_pros_lite', JSON.stringify(response.data));
        set_category_pro_disabled(false);
        setIsOpen4(true);
        peding_service(false);
    };
    const change_category_pro_max = (event) => {
        localStorage.setItem("orders_reload", "NO");
        setIsOpen3(false);
        const selectedOption = event.value;
        const selectedOptionok = category_pros_max.find(
            (option) => option.id == selectedOption);
        console.log(selectedOptionok);
        set_category_pro_max(selectedOptionok);
        localStorage.setItem('category_pro_max', JSON.stringify(selectedOptionok));
        if (selectedOptionok.api_categorymini == 'only_category') {
            set_category_pro_lite(selectedOptionok);
            localStorage.setItem('category_pro_lite', JSON.stringify(selectedOptionok));
        }
        else if (selectedOptionok.option) {
            get_info_category_pro(selectedOptionok.option);
        }
    };
    const change_category_pro = (event) => {
        localStorage.setItem("orders_reload", "NO");
        setIsOpen4(false);
        const selectedOption = event.value;
        const selectedOptionok = category_pros_lite.find(
            (option) => option.id == selectedOption
        );
        console.log(selectedOptionok.category);
        set_category_pro_lite(selectedOptionok);
        localStorage.setItem('category_pro_lite', JSON.stringify(selectedOptionok));
    };

    // Component Option tùy chỉnh
    const CustomOption3 = ({ innerRef, innerProps, data }) => (
        <button ref={innerRef} {...innerProps} className="flex items-center p-2">
            <img src={data.img} alt={data.label} className="w-7 h-7 mr-2" />
            <div className="text-base">{data.label}
            </div>
        </button>
    );
    // Component SingleValue tùy chỉnh sử dụng Tailwind CSS
    const CustomSingleValue3 = ({ innerRef, innerProps, data }) => (
        <button ref={innerRef} {...innerProps} className="flex items-center -mt-6" >
            <img src={data.img} alt={data.label} className="w-7 h-7 mr-2" />
            <div className="text-base">{data.label}
            </div>
        </button>
    );
    const orders_category = {
        "en": {
            "select_platform": "Select your platform",
            "select_genre": "Select your genre"
        },
        "vi": {
            "select_platform": "Chọn nền tảng của bạn",
            "select_genre": "Chọn thể loại của bạn"
        }
    };
    return (
        <>
            <div className="text-center justify-center text-sm">{orders_category[lang]?.select_platform || orders_category.en.select_platform}</div>
            <Select
                classNamePrefix="Chọn 1 lựa chọn"
                onFocus={handleFocus3}
                options={category_pros_max.map((option) => ({
                    value: option.id,
                    label: option.name,
                    img: option.img // Thêm thuộc tính img cho tùy chọn
                }))}
                components={{ Option: CustomOption3, SingleValue: CustomSingleValue3 }} // Sử dụng Option và SingleValue tùy chỉnh
                menuIsOpen={isOpen3}
                isDisabled={category_pro_max_disabled} // Khi isDisabled là true, người dùng không thể chọn
                onBlur={handleBlur3}
                onMenuOpen={handleMenuOpen3}
                value={
                    category_pro_max.id
                        ? {
                            value: category_pro_max.id,
                            label: category_pro_max.name,
                            img: category_pro_max.img
                        }
                        : null
                }
                onChange={change_category_pro_max} // Use selectedOption.value to get the selected value
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={false}
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        maxHeight: 'none', // Xóa giới hạn chiều cao
                        height: 'auto',    // Thiết lập chiều cao tự động dựa trên số lượng tùy chọn
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: 'none', // Xóa giới hạn chiều cao của danh sách tùy chọn
                    })
                }}
            />
            {(category_pro_max.api_categorymini == 'only_category_pro') &&
                (<>
                    <div className="text-center justify-center text-sm">{orders_category[lang]?.select_genre || orders_category.en.select_genre}</div>
                    <Select
                        classNamePrefix="Chọn 1 lựa chọn"
                        onFocus={handleFocus4}
                        components={{ Option: CustomOption3, SingleValue: CustomSingleValue3 }} // Sử dụng Option và SingleValue tùy chỉnh
                        options={category_pros_lite.map((option) => ({
                            value: option.id,
                            label: option.name,
                            img: option.img // Thêm thuộc tính img cho tùy chọn
                        }))}
                        menuIsOpen={isOpen4}
                        isDisabled={category_pro_disabled} // Khi isDisabled là true, người dùng không thể chọn
                        onBlur={handleBlur4}
                        onMenuOpen={handleMenuOpen4}
                        value={
                            category_pro_lite.id
                                ? {
                                    value: category_pro_lite.id,
                                    label: category_pro_lite.name,
                                    img: category_pro_lite.img
                                }
                                : null
                        }
                        onChange={change_category_pro} // Use selectedOption.value to get the selected value
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={false}
                    />
                </>)}
        </>
    );
}
export default Ordergoogle;
